import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { Sprint } from "../../interfaces/sprint";
import { MzBaseModal } from "ng2-materialize";
import { Project } from "../../interfaces/project";
import { Utils } from "../../utils/utils";

@Component({
  selector: "app-edit-sprint-dialog",
  templateUrl: "./edit-sprint-dialog.component.html",
  styleUrls: ["./edit-sprint-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditSprintDialogComponent extends MzBaseModal implements OnInit {
  readonly env: any = environment;
  readonly utils: any = Utils;

  @Input() project: Project;

  @Output() createSprintClicked: EventEmitter<any> = new EventEmitter<any>();

  newSprint: Sprint;

  constructor() {
    super();
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.newSprint = {} as Sprint;
  }

  /**
   * creates new Item
   */
  createSprint() {
    if (this.newSprint.name && this.newSprint.name.trim() !== "") {
      this.newSprint.projectId = this.project._id;
      if (this.project.sprints.length > 0) {
        this.newSprint.index =
          Array.from(this.project.sprints).sort((x, y) => x.index - y.index)[0]
            .index - 1;
      }
      console.log(this.newSprint);
      this.createSprintClicked.emit(this.newSprint);
      this.newSprint = {} as Sprint;
    }
  }

  /**
   * resets newItem object and closes modal
   * @param modal
   */
  closeSprintModal() {
    this.newSprint = {} as Sprint;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/edit-sprint-dialog/edit-sprint-dialog.component.ts